/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'cmp-google-maps';

export class GoogleMap extends Component {

    /**
     * Get Data From Data-Attrs
     */
    getInitialData() {
        const { latitude, longitude, zoom } = this.element.dataset;
        this.zoom = parseInt(zoom, 10);
        this.coordinates = {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
        };
    }

    /**
     * Create Map
     */
    createMap() {
        if(!window.google) return;

        const map = new window.google.maps.Map(this.elements.map, {
            center: this.coordinates,
            zoom: this.zoom,
        });

        const marker = new window.google.maps.Marker({
            position: this.coordinates,
            map,
        });

        // Store the current map in case we want to do something dynamic in the future
        this.currentMap = { map, marker };

    }

    /**
     * Initialize Component
     */
    init() {
        // Set Up Default Data
        this.zoom = null;
        this.coordinates = {
            lat: null,
            lng: null,
        };
        this.currentMap = {
            map: null,
            marker: null,
        };

        // Set Up Elements
        this.elements = {
            map: this.element.querySelector(`.${componentName}__map`),
        };

        // Fire Init Funcs
        this.getInitialData();
        this.createMap();
    }

}

/**
 * Register Component
 * - if the Maps API has completed loading, do registerComponent
 * - else if the callback function still exists (API not loaded), replace callback to be registerComponent
 */
if (window.googleMapsLoaded === true) {
    registerComponent(`.${componentName}`, GoogleMap);
} else if (typeof window.googleMapsLoaded === 'function') {
    window.googleMapsLoaded = function loadedCallback() {
        registerComponent(`.${componentName}`, GoogleMap);
    };
}
